/**
 * Format a number as currency
 */
export function formatCurrency(
  amount: number | string,
  currency = 'USD',
  locale = 'en-US'
): string {
  const num = typeof amount === 'string' ? parseFloat(amount) : amount
  return new Intl.NumberFormat(locale, {
    style: 'currency',
    currency,
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  }).format(num)
}

/**
 * Format a number with token symbol
 */
export function formatTokenAmount(
  amount: number | string,
  token: string,
  decimals = 2
): string {
  const num = typeof amount === 'string' ? parseFloat(amount) : amount
  return `${num.toLocaleString('en-US', {
    minimumFractionDigits: decimals,
    maximumFractionDigits: decimals,
  })} ${token}`
}

/**
 * Format a date string
 */
export function formatDate(
  date: string | Date,
  options: Intl.DateTimeFormatOptions = {
    year: 'numeric',
    month: 'short',
    day: 'numeric',
  }
): string {
  const d = typeof date === 'string' ? new Date(date) : date
  return d.toLocaleDateString('en-US', options)
}

/**
 * Truncate a wallet address for display
 */
export function truncateAddress(address: string, chars = 4): string {
  if (address.length <= chars * 2 + 3) return address
  return `${address.slice(0, chars)}...${address.slice(-chars)}`
}

/**
 * Get status badge color
 */
export function getStatusColor(status: string): {
  bg: string
  text: string
} {
  switch (status) {
    case 'paid':
      return { bg: 'bg-success/10', text: 'text-success' }
    case 'sent':
    case 'viewed':
      return { bg: 'bg-brand/10', text: 'text-brand' }
    case 'overdue':
      return { bg: 'bg-error/10', text: 'text-error' }
    case 'cancelled':
      return { bg: 'bg-neutral/10', text: 'text-neutral' }
    default:
      return { bg: 'bg-surface-subtle', text: 'text-text-subtle' }
  }
}
